import {combineReducers} from 'redux';
import {commonReducer} from './common/reducers';
import {i18nReducer} from './i18n/reducers';
import {offersReducer} from './offers/reducers';
import {userReducer} from './user/reducers';
import {dealsReducer} from './deals/reducers';
import {agentsReducer} from './agents/reducers';
import {partnersReducer} from './partners/reducers';
import {referralsReducer} from './referrals/reducers';
import {globalConfigReducer} from './global/reducers';
import {olxImportReducer} from './olx-import/reducers';
import {agencyFeedReducer} from './agency-feed/reducers';
import {profileReducer} from './profile/reducers';
import {subscriptionReducer} from './subscription/reducer';
import {gameQuizReducer} from './game-quiz/reducer';
import {marketActivityReducer} from './market-activity/reducer';
import {userSettingsReducer} from './userSettings/reducer';
import {objectsReducer} from './objects/reducer';
import {localStoreReducer} from './local/reducer';

export const rootReducer = combineReducers({
  common: commonReducer,
  i18n: i18nReducer,
  offers: offersReducer,
  deals: dealsReducer,
  referrals: referralsReducer,
  user: userReducer,
  userSettings: userSettingsReducer,
  agents: agentsReducer,
  partners: partnersReducer,
  globalConfig: globalConfigReducer,
  olxImport: olxImportReducer,
  agencyFeed: agencyFeedReducer,
  profile: profileReducer,
  subscription: subscriptionReducer,
  gameQuiz: gameQuizReducer,
  marketActivity: marketActivityReducer,
  objects: objectsReducer,
  localStore: localStoreReducer
});
